import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/layout';
import Footer from 'components/footer';
import TourDates from 'components/tourdates';
import Hero from 'components/hero';
import Music from 'components/music';
import MailingList from 'components/mailinglist';
import Videos from 'components/videos';
import GDPR from 'components/gdpr';
import { graphql } from 'gatsby';

const Index = () => (
  <Layout>
    <Hero />
    <MailingList />
    <Music />
    <Videos />
    <TourDates />
    <Footer />
    <GDPR />
  </Layout>
);

Index.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Index;

export const query = graphql`
  query HomepageQuery {
    homeJson {
      title
      content {
        childMarkdownRemark {
          html
          rawMarkdownBody
        }
      }
      gallery {
        title
        copy
        image {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
